import { applyOnlineVisitPatientDisplayBufferMs } from '@/modules/booking/utils/onlineVisitPatientDisplayTime';
import moment from 'jalali-moment';

/** Invoice notice: first free online-visit slot, with the patient buffer (+15 then ceil-to-5). */
export const getFreeturnDisplayText = (freeturnMs: number | null): string => {
  if (freeturnMs === null) return 'در اسرع وقت';
  if (freeturnMs < Date.now()) return 'در کمتر از ۱۵ دقیقه آینده';

  const displayMs = applyOnlineVisitPatientDisplayBufferMs(freeturnMs);

  return moment(displayMs).locale('fa').calendar(undefined, {
    nextWeek: 'YYYY/MM/DD(dddd) حدود ساعت HH:mm',
    sameElse: 'YYYY/MM/DD حدود ساعت HH:mm',
    sameDay: 'امروز حدود ساعت HH:mm',
    nextDay: 'فردا حدود ساعت HH:mm',
  });
};
